export default __webpack_public_path__ + "static/media/CrabAddingTemplate.3d26a5f6.xlsx";